<div class="dynamic-html" [innerHTML]="data | safeHtml"></div>
